// "Switch ON your Set-Top Box and TV" pop-up (owner rule 2026-10-04), customer screens only:
// portal Renew page, portal Payments "Pay Online" and the public pay link (server-computed
// there, backend routes/publicPay.js). Shown before a CableTV payment by a DTD customer, or
// by a regular customer the CRM has marked suspended on GTPL (catv.gtplSuspended), because
// that payment re-activates the box and the recharge only lands while the box is on.
// `c` is the customer record that holds the CableTV connection.
export function stbOnNoticeApplies(c) {
  if (!c || !c.catv || !['catv', 'both'].includes(c.customerType)) return false;
  if (c.billing?.durationType === 'dtd') return true;
  return c.catv.gtplSuspended === true;
}
